import axios from 'axios'

export function sendEmail(target = '', subject = '', formString = '') {
  return axios({
    url: '/service/email/send',
    method: 'POST',
    data: { subject, to: target, html: formString },
  })
}
